import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { VideoPlayButton } from '$quantum/atoms/VideoPlayButton';
import type { ImageData } from '$util/types';
import { Img } from '@/components/atoms/Img';
import styles from './index.module.scss';

export interface CustomerCarouselItemProps extends HTMLAttributes<HTMLDivElement> {
  readonly name: string;
  readonly quote: string;
  readonly saved: string;
  readonly service: string;
  readonly image: ImageData;
  readonly videoUrl?: string;
  readonly onVideoButtonClick?: () => void;
}

export function CustomerCarouselItem({
  className,
  image,
  name,
  quote,
  saved,
  videoUrl,
  onVideoButtonClick,
  service,
  ...props
}: CustomerCarouselItemProps): JSX.Element {
  return (
    <div
      className={classNames(
        styles.customerCarouselItemContainer,
        CustomerCarouselItem.displayName,
        className
      )}
      {...props}
    >
      <div className={styles.customerCarouselItem}>
        <div className={styles.customerCarouselMediaWrapper}>
          {videoUrl && (
            <VideoPlayButton
              className={styles.videoPlayButton}
              onClick={() => {
                onVideoButtonClick?.();
              }}
            />
          )}
          {image && (
            <Img
              className={styles.image}
              provider="cloudinary"
              src={image.url}
              width={image.width}
              height={image.height}
              alt={image.alt}
              title={image.title}
              layout="responsive"
              objectFit="cover"
            />
          )}
        </div>
        <div className={styles.customerCarouselItemText}>
          <h3 className={styles.customerCarouselItemName}>{name}</h3>
          <p className={styles.customerCarouselItemQuote}>“{quote}”</p>
          <div className={classNames(styles.customerCarouselItemMeta, styles.flex)}>
            <div className={styles.customerCarouselItemSaved}>{saved}</div>
            <p className={styles.customerCarouselItemService}>{service}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
CustomerCarouselItem.displayName = 'CustomerCarouselItem';
